import { useState } from "react";
import { Film } from "lucide-react";
import { imageUrl } from "@/lib/api";

export const Poster = ({ id, type = "poster", alt, className = "", iconSize = 32 }) => {
  const [failed, setFailed] = useState(false);
  if (failed || !id) {
    return (
      <div className={`flex items-center justify-center bg-gradient-to-br from-[#F2F0E9] to-[#E7E3D8] text-zinc-400 ${className}`}>
        <Film size={iconSize} strokeWidth={1.25} />
      </div>
    );
  }
  return <img src={imageUrl(id, type)} alt={alt} loading="lazy" onError={() => setFailed(true)} className={`object-cover ${className}`} />;
};

export const ProgressLine = ({ value, className = "" }) => (value > 0 ? (
  <div className={`h-1 w-full bg-black/20 ${className}`}>
    <div className="h-full bg-amber-500" style={{ width: `${value}%` }} />
  </div>
) : null);
